<template>
  <div v-if="chargeTypesUpdating" class="loading">
    <client-only>
      <loading-spinner location="pitch-types-list" />
    </client-only>
  </div>
  <div
    v-else-if="pitchtypes.length"
    class="pitchtypes-list"
    :class="{ desktop: $isDesktop }"
  >
    <div class="title">
      <slot name="title" />
    </div>
    <ul>
      <li v-for="(pitchtype, index) in pitchtypes" :key="pitchtype.id">
        <slot name="card" :pitchtype="pitchtype" :pitchtype-index="index" />
      </li>
    </ul>
  </div>
  <div
    v-else-if="!pitchtypes.length"
    class="no-availability"
    :class="{ desktop: $isDesktop }"
  >
    <translate tag="p">
      No availability here for your search criteria
    </translate>
  </div>
  <div v-else>
    <!-- empty div but we shouldn't have v-if on parent components -->
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PitchType } from '../../campsite-details/types'

@Component
class PitchTypesList extends Vue {
  @Prop()
  pitchtypes: PitchType[]

  @Prop({ required: false })
  chargeTypesUpdating: boolean
}

export default toNative(PitchTypesList)
</script>
<style scoped>
.pitchtypes-list {
  padding: 0.5em 0.8em 0.5em;
  margin-bottom: 0.8em;
}

.title {
  color: var(--colour-dark-blue);
  font-size: var(--body);
  font-weight: bold;
  padding-bottom: 0.5em;
}

.pitchtypes-list li {
  margin: 0 0 1.6em;
}

.pitchtypes-list li:last-of-type {
  margin-bottom: 0;
}

.loading {
  padding: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-availability {
  padding: 0.5em 0.8em 1em;
}

.no-availability p {
  font-size: var(--body);
}

/* desktop & tablet */
.pitchtypes-list.desktop {
  padding: 0;
}

.pitchtypes-list.desktop ul {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2em;
}

.pitchtypes-list.desktop li {
  margin: 0;
}

.desktop .title {
  font-size: initial;
  padding: 1em 0;
}

.no-availability.desktop {
  padding: 0;
}

.no-availability.desktop p {
  font-size: initial;
}

/* large desktop */
@media only screen and (min-width: 94em) {
  .pitchtypes-list.desktop ul {
    grid-template-columns: 1fr 1fr;
  }
}

@media (hover: hover) {
  .pitchtypes-list.desktop li:hover :deep(.pitchtype) {
    box-shadow: 0 0 0 0.33em var(--colour-dark-green);
    transition: box-shadow 150ms ease-out;
  }

  .pitchtypes-list.desktop li:hover :deep(.view-prices) {
    background-color: var(--colour-dark-green);
    transition: transform 150ms ease-out;
  }
}

.pitchtypes-list.desktop li :deep(a:focus-visible) {
  outline: none;
  border-radius: 0.6em;
  box-shadow: 0 0 0 0.33em var(--colour-dark-green);
  transition: box-shadow 150ms ease-out;
}
</style>
